const VERIFY_BASE_URL = (
  process.env.REACT_APP_VERIFY_BASE_URL || 'http://localhost:5005/api/v1/verify'
).replace(/\/+$/, '');

export const REQUESTS_URI =
  process.env.REACT_APP_VERIFY_REQUESTS_URL || `${VERIFY_BASE_URL}/requests`;

export const REQUEST_URI =
  process.env.REACT_APP_VERIFY_REQUEST_URL ||
  `${VERIFY_BASE_URL}/request-object`;

export const STATUS_URI =
  process.env.REACT_APP_VERIFY_STATUS_URL || `${VERIFY_BASE_URL}/status`;

export const FACE_VERIFICATION_URI =
  process.env.REACT_APP_FACE_VERIFY_URL || `${VERIFY_BASE_URL}/face`;

export const POLL = {
  // 실제 서버를 쓰려면 원래 값으로 두고,
  // 테스트하려면 아래처럼 바꿔 사용:
  // 'mock:success?role=representative' | 'mock:error' | 'mock:random' | 'mock:idle'
  STATUS_URL: STATUS_URI,
  INTERVAL_MS: 1500,
  TIMEOUT_MS: Number(process.env.REACT_APP_VERIFY_POLL_TIMEOUT_MS) || 600000,
  MAX_CONSECUTIVE_ERRORS:
    Number(process.env.REACT_APP_VERIFY_POLL_MAX_ERRORS) || 5,
};

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

export const FACE_CAPTURE = {
  JPEG_QUALITY: clamp(
    Number(process.env.REACT_APP_FACE_JPEG_QUALITY) || 0.9,
    0.1,
    1
  ),
  MAX_WIDTH: Number(process.env.REACT_APP_FACE_MAX_WIDTH) || 1280,
};

export const FACE_VERIFICATION = {
  URL: FACE_VERIFICATION_URI,
  TIMEOUT_MS: Number(process.env.REACT_APP_FACE_VERIFY_TIMEOUT_MS) || 90000,
};

export const FACE_DETECTION = {
  WASM_BASE_URL:
    process.env.REACT_APP_FACE_DETECTOR_WASM_URL ||
    'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@1.0.1/wasm',
  MODEL_URL:
    process.env.REACT_APP_FACE_DETECTOR_MODEL_URL ||
    'https://storage.googleapis.com/mediapipe-models/face_detector/blaze_face_short_range/float16/1/blaze_face_short_range.tflite',
  MIN_CONFIDENCE:
    Number(process.env.REACT_APP_FACE_DETECTOR_MIN_CONFIDENCE) || 0.7,
  SCAN_INTERVAL_MS:
    Number(process.env.REACT_APP_FACE_DETECTOR_SCAN_INTERVAL_MS) || 160,
  STABLE_DURATION_MS:
    Number(process.env.REACT_APP_FACE_DETECTOR_STABLE_MS) || 900,
};

export const isUiPreviewEnabled = () => {
  const hostname = globalThis.location?.hostname;
  const isLocalhost =
    hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1';

  return (
    process.env.NODE_ENV === 'development' ||
    isLocalhost
  );
};
